
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.95777 0C6.27171 0 6.52621 0.254528 6.52621 0.568498V2.69544H11.3471C11.661 2.69544 11.9156 2.94996 11.9156 3.26393C11.9156 3.5779 11.661 3.83243 11.3471 3.83243H6.52621V5.95735C6.52621 6.27133 6.27171 6.52585 5.95777 6.52585C5.64382 6.52585 5.38933 6.27133 5.38933 5.95735V0.568498C5.38933 0.254528 5.64382 0 5.95777 0ZM14.0423 0C14.3562 0 14.6107 0.254528 14.6107 0.568498V2.69544H16.3999C18.3884 2.69544 20 4.30729 20 6.29592V16.3995C20 18.3882 18.3884 20 16.3999 20H3.60013C1.61168 20 0 18.3882 0 16.3995V6.29592C0 4.30729 1.61168 2.69544 3.60013 2.69544C3.91406 2.69544 4.16857 2.94996 4.16857 3.26393C4.16857 3.5779 3.91406 3.83243 3.60013 3.83243C2.23957 3.83243 1.13688 4.93523 1.13688 6.29592V9.43148H15.3893C15.7033 9.43148 15.9578 9.68601 15.9578 9.99997C15.9578 10.314 15.7033 10.5685 15.3893 10.5685H1.13688V16.3995C1.13688 17.7602 2.23957 18.863 3.60013 18.863H16.3999C17.7605 18.863 18.8631 17.7602 18.8631 16.3995V6.29592C18.8631 4.93523 17.7605 3.83243 16.3999 3.83243H14.6107V5.95735C14.6107 6.27133 14.3562 6.52585 14.0423 6.52585C13.7284 6.52585 13.4738 6.27133 13.4738 5.95735V0.568498C13.4738 0.254528 13.7284 0 14.0423 0Z","fill":"#6C18E1"}})])
          )
        }
      }
    